<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <b-container>
            <b-row>
                <b-col cols="12" md="5" lg="3">
                    <Sidenav/>
                </b-col>
                <b-col cols="12" md="7" lg="9" class="call-center" v-if="content.length">
                    <h2 class="mt-4 mb-4 call-center-title"> Dúvidas frequentes </h2>
                    <div class="accordion" role="tablist">
                        <b-card no-body class="border-0 mb-3" v-for="item in content" :key="item.id">
                            <b-button block v-b-toggle="`accordion-${item.id}`" class="text-left call-center-accordion-btn d-flex justify-content-between" @click="idVisible == item.id ? idVisible = null : idVisible = item.id">
                                <div>{{ item.name }}</div>
                                <div v-if="idVisible && idVisible == item.id">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="3">
                                        <rect width="15" height="3" fill="#000" class="call-center-accordion-btn-icon"/>
                                    </svg>
                                </div>
                                <div v-else>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" class="call-center-accordion-btn-icon"><path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>
                                </div>
                            </b-button>
                            <b-collapse :id="`accordion-${item.id}`" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text v-html="item.text1" class="call-center-accordion-text"></b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import Breadcrumb from '~/components/Breadcrumb';
import Sidenav from '~/components/Sidenav';
export default{
    data(){
        return{
            idVisible: null
        }
    },
    computed: {
        breadcrumb() {
            let breadcrumb = [
                {
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Central de atendimento',
                    link: null
                },
                {
                    name: 'Dúvidas frequentes',
                    link: null
                }
            ];
            return breadcrumb;
        },
    },
    components:{
        Breadcrumb,
        Sidenav
    },
    async asyncData({params, res, $axios, req, app, error}) {
        try {
            const content = await $axios.$get(`api/v1/cms/?category_code=2&limit=100`);
            return {
                content: content.data
            }
        } catch (e) {
            console.error(e)
            // return error({statusCode: 404, message: e.message})
        }
    }
}
</script>
